<template>
  <div class=''>
    <label v-bind:for='list.instanceGuid' v-text='(list.nickName.length <= 0) ? "Unknown" : list.nickName'></label>
    <div class='item'>
      <select v-bind:id='list.instanceGuid' v-model='value'>
        <option v-for='(key, idx) in list.keys' v-bind:value='list.values[idx]' v-text='key' :key="idx">
        </option>
      </select>
    </div>
  </div>
</template>

<script>

import UIBase from './UIBase.vue';

export default {
  name: 'EMaterialList',
  extends: UIBase,
  props: {
    // GHMaterialListObject
    list: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    value: {
      get () {
        return this.list.values[this.list.selected];
      },
      set (v) {
        let index = this.list.values.indexOf(v);
        if (this.list.value !== index) {
          this.list.change(index);
        }
      }
    }
  }
};

</script>



// WEBPACK FOOTER //
// src/components/EMaterialList.vue